import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-rewards-nav',
  templateUrl: './rewards-nav.component.html',
  styleUrls: ['./rewards-nav.component.less']
})
export class RewardsNavComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  title: string;

  constructor(private router: Router) { }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  RewardsMenuitems = [{
    title: 'My Rewards',
    routerLink: '/rewards/my-rewards'
  }, {
    title: 'All Rewards',
    routerLink: '/rewards'
  }, {
    title: 'Offers',
    routerLink: '/rewards/offers'
  }]; 
  ngOnInit(): void {
    this.setActiveTab(this.router.url);
    this.subscriptions.add(this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe(e => {
        const currentUrl = e['url'];
        this.setActiveTab(currentUrl);
      }));
  }

  private setActiveTab(currentUrl: any) {
    const url = currentUrl.split('?')[0];
    if (url.endsWith('/rewards')) {
      this.title = 'All Rewards';
    } else if (url.endsWith('/rewards/my-rewards')) {
      this.title = 'My Rewards';
    } else if (url.endsWith('/rewards/offers')) {
      this.title = 'Offers';
    }
  }
}
